import { useMemo } from 'react';

import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { NestedPageLayout } from '#apps/client-web/app/components/nested-page-layout';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { clock } from '#apps/client-web/app/services/clock';
import { auditService } from '#apps/client-web/features/audit/services/audit';
import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { exportApiService } from '#apps/client-web/features/export/services/export-api';
import { ExportProgressSnackbar } from '#apps/client-web/features/export/components/export-progress-snackbar';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditDetailsPageContainer } from './audit-details-page.container';
import { useAuditDetailsPageViewModel } from './audit-details-page.view-model';
import { AuditDetailsPageMenu } from './audit-details-page-menu';

export const AuditDetailsPage = () => {
  const logger = useLogger('pages/audit-details');

  const viewModel = useAuditDetailsPageViewModel({
    auditService,
    auditFormService,
    exportApiService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    clock,

    logger,
  });

  const title = useMemo(() => {
    if (viewModel.page.state === 'loading') {
      return 'Loading...';
    }

    if (viewModel.page.state === 'error') {
      return 'Error';
    }

    return viewModel.page.data.title;
  }, [viewModel.page]);

  const { mainMenu, onExport, onDelete } = viewModel;

  return (
    <NestedPageLayout
      title={title}
      headerChildren={
        viewModel.page.state === 'success' && (
          <AuditDetailsPageMenu
            /* Menu state */
            onClose={mainMenu.close}
            onOpen={mainMenu.open}
            isOpen={mainMenu.isOpen}
            anchorEl={mainMenu.anchorEl}
            /* Menu actions */
            onExport={onExport}
            onDelete={onDelete.bind(null, { confirmed: false })}
            isExportPending={viewModel.isExportPending}
          />
        )
      }>
      <CenteredLayout horizontal>
        <AuditDetailsPageContainer viewModel={viewModel} logger={logger} />
      </CenteredLayout>
      <ExportProgressSnackbar
        open={viewModel.isExportPending || viewModel.exportProgress !== null}
        progress={viewModel.exportProgress}
        onClose={viewModel.dismissExportProgress}
      />
    </NestedPageLayout>
  );
};
